<script>
    import { link } from "svelte-spa-router";
    import CookbookService from "../server/service/CookbookService";

    export let params;
</script>

{#await (CookbookService.getData(params.id))}
    <p>Loading...</p>
{:then cookbook}
    <article class="cookbook">
        <h1>{cookbook.title}</h1>
        <p>{cookbook.created}</p>
        <p>{cookbook.description}</p>
        <ol>
            {#each cookbook.recipes as recipe}
                <li>
                    <a href="/recipes/{recipe.id}" use:link>[{recipe.id}] {recipe.title}</a>
                </li>
            {/each}
        </ol>
    </article>
{:catch error}
    <p style="color: red">{error.message}</p>
{/await}
